import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { sessionService } from '@/providers/services/auth/session';
import ToolPullUp from '../super-user-tool/tool-pullup/tool-pullup';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';

@Component({
    name: 'district-data-tool',
    components: {
        'material-icons': GoogleMaterialIcon,
        'tool-pull-up': ToolPullUp,
    },
})

export default class DistrictDataLake extends Vue {

    // ----------------------------------------------------------
    // Properties

    @Prop()
    private toolProvider!: any;

    @Prop()
    private activeScreen!: any;

    private activeTool: any = [];

    private activePerformace: number = 0;

    private isCompareToggle: boolean = false;

    private toolDataBySubject: any = [];

    private isLogoSelected: boolean = false;

    private activeCompareData: any = [];

    private showModal: boolean = false;

    private dataLakeIcon: string = DEFAULT_IMAGES_PATH.dataLakeIcon;

    private dataLakeLearning: string = DEFAULT_IMAGES_PATH.dataLakeLearning;

    // --------------------------------------------------------------
    // Hooks

    private created() {
        this.toolDataBySubject = this.parseDataBySubjects(this.toolProvider);
    }

    // ------------------------------------------------------------------
    // Actions

    private parseDataBySubjects(toolData: any) {
        const subjects: any = [...new Set(toolData.map((item: any) => item.subject))]
            .filter((item: any) => item);
        const dataList: any = [];
        subjects.forEach((subject: any) => {
            const dataLevel = {
                subject,
                toolData: this.createGroupSubject(toolData, subject),
            };
            dataList.push(dataLevel);
        });
        return dataList;
    }

    private createGroupSubject(toolData: any, subject: string) {
        return toolData.filter((item: any) => (item.subject === subject));
    }


    private showPerformancePopUp(tool: any) {
        this.resetData();
        this.activeTool = tool;
    }

    private resetData(isClearComparedata: boolean = true) {
        if (isClearComparedata) {
            this.activeCompareData = [];
            this.toolProvider.forEach((tool: any) => {
                tool.isActive = false;
            });
        }
        this.isCompareToggle = false;

    }

    // ------------------------------------------------------------------------
    // methods

}
